import { defineMessages } from 'react-intl-next';

export default defineMessages({
	workItem: {
		id: 'navigation.preview-panel-global-objects.workItem',
		defaultMessage: 'Jira work item',
		description: 'Title for the work item preview panel',
	},
	project: {
		id: 'navigation.preview-panel-global-objects.project',
		defaultMessage: 'Project',
		description: 'Title for the project preview panel',
	},
	goal: {
		id: 'navigation.preview-panel-global-objects.goal',
		defaultMessage: 'Goal',
		description: 'Title for the goal preview panel',
	},
	team: {
		id: 'navigation.preview-panel-global-objects.team',
		defaultMessage: 'Team',
		description: 'Title for the team preview panel',
	},
	page: {
		id: 'navigation.preview-panel-global-objects.page',
		defaultMessage: 'Confluence Page',
		description: 'Title for the Confluence page preview panel',
	},
	whiteboard: {
		id: 'navigation.preview-panel-global-objects.whiteboard',
		defaultMessage: 'Confluence Whiteboard',
		description: 'Title for the Confluence whiteboard preview panel',
	},
	object: {
		id: 'navigation.preview-panel-global-objects.object',
		defaultMessage: 'Assets Object',
		description: 'Title for the object preview panel',
	},
});
